module.exports = __webpack_public_path__ + "img/empty.63e7a2c9.svg";